// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/home/gitlab-runner/builds/_wi3V95W/0/poz/pozitiff-pay-frontend/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/home/gitlab-runner/builds/_wi3V95W/0/poz/pozitiff-pay-frontend/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/home/gitlab-runner/builds/_wi3V95W/0/poz/pozitiff-pay-frontend/.cache/data.json")

